import apiClient from './axiosConfig'; // Import apiClient
import { API_ENDPOINTS } from '../constants';

// Removed individual caching logic, now handled by axiosConfig interceptors

const fetchTestimonials = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.paginate) query.append('paginate', params.paginate);
  if (params.limit) query.append('limit', params.limit);
  if (params.per_page) query.append('per_page', params.per_page);
  if (params.page) query.append('page', params.page);

  try {
    const response = await apiClient.get(`${API_ENDPOINTS.TESTIMONIALS}?${query.toString()}`); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching Testimonials data:', error);
    throw error;
  }
};

export { fetchTestimonials };